!function (angular) {
    "use strict";

    var widgetsSignoutControllers = angular.module("controllers.service.widgets.signout", []);

    widgetsSignoutControllers.controller("wSignoutSelectedPartCtrl", ['$scope', '$translate', 'componentMetaDataService', 'serviceRequestSignOut', function ($scope, $translate, componentMetaDataService, serviceRequestSignOut) {

        $scope.availableParts = [];
        $scope.selectedParts = [];
        $scope.error = false;
        $scope.signOff = {
            noPartSelection: false
        };

        $scope.pageInfo = {
            totalPages: 0,
            size: 6
        };

        $scope.filter = {
            id: 1,
            description: "",
            page: 0
        };

        $scope.paginate = function (page) {
            $scope.filter.page = page;
            serviceRequestSignOut.get().serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
                var serviceEvent = serviceEvent;
                serviceEvent.$get("machine").then(function (machine) {
                    $scope.filter.id = machine.machineMetaDataId;
                    componentMetaDataService.findPartsMetadata($scope.filter).then(function (resource) {
                            $scope.pageInfo = resource.page;
                            resource.$get("componentMetaDataList").then(function (partList) {
                                $scope.availableParts = partList;
                                $scope.error = false;
                            });
                        },
                        function (status) {
                            if (status.status === 404) {
                                $scope.error = true;
                            }
                        });
                });
            });
        };

        $scope.doSearch = function () {
            $scope.paginate(0);
        };

        $scope.addPart = function (index) {
            if(!$scope.signOff.noPartSelection) {
                var part = $scope.availableParts[index];
                var selectedPart = {'componentMetaData': part, 'quantity': 0};
                $scope.selectedParts.unshift(selectedPart);
            }
        };

        $scope.removePart = function (index) {
            $scope.selectedParts.splice(index, 1);
        };

        $scope.paginate(0);
    }]);

    widgetsSignoutControllers.controller("wSignoutMissingPartCtrl", ['$scope', '$controller', 'componentMetaDataService', 'serviceRequestSignOut', function ($scope, $controller, componentMetaDataService, serviceRequestSignOut) {

        if (!serviceRequestSignOut.get().outcome.partNotAvailable)
            $scope.$parent.next(true);

        angular.extend(this, $controller('wSignoutSelectedPartCtrl', {$scope: $scope}));

        $scope.partType = "missing";

        $scope.next = function () {
            serviceRequestSignOut.setMissingParts($scope.selectedParts);
            $scope.$parent.next();
        };
    }]);

    widgetsSignoutControllers.controller("wSignoutUsedPartCtrl", ['$scope', '$controller', 'componentMetaDataService', 'serviceRequestSignOut', '$translate', 'serviceRequestService', function ($scope, $controller, componentMetaDataService, serviceRequestSignOut, $translate, serviceRequestService) {

        angular.extend(this, $controller('wSignoutSelectedPartCtrl', {$scope: $scope}));

        $scope.partType = "used";
        $scope.partError = false;

        $scope.next = function () {
            serviceRequestService.getPartSelection().then(function (response) {
                var partSelectionConfig = response.content;

                if(partSelectionConfig && !$scope.signOff.noPartSelection && $scope.selectedParts.length == 0) {
                    $scope.partError = true;
                    $scope.partErrorMessage = $translate.instant('label.controller.services.controller.NoPartSelection');
                } else {
                    $scope.partError = false;
                    serviceRequestSignOut.setUsedParts($scope.selectedParts);
                    serviceRequestSignOut.setNoPartSelection($scope.signOff.noPartSelection);
                    $scope.$parent.next();
                }
            });
        };

        $scope.$watch('signOff.noPartSelection', function (newValue, oldValue) {
            if(newValue) {
                $scope.selectedParts = [];
            }
        });

        $scope.clostPartError = function () {
            $scope.partError = false;
        };
    }]);

    widgetsSignoutControllers.controller("wSingoutModelPropertiesCtrl", ['$scope', function ($scope) {
    }]);

    widgetsSignoutControllers.controller("wSignOutCommonCauseCtrl", ['$scope', '$translate', 'serviceRequestSignOut', function ($scope, $translate, serviceRequestSignOut) {

        $scope.widgetInfo = {
            goBack: false,
            title: $translate.instant('label.controller.services.signOutController.SelectCommonCause')
        };

        $scope.selectedCommonCause = {};
        $scope.parentCommonCauses = [];
        $scope.currentCommonCauses = [];

        serviceRequestSignOut.get().serviceRequest.$get('commonCauses').then(
            function (resource) {
                if (resource == null || (resource != null && resource.page.totalElements == 0)) {
                    $scope.$parent.next(true);
                }
                resource.$get("commonCauseList").then(function (commonCauses) {
                    if (commonCauses != null && commonCauses.length > 0) {
                        $scope.parentCommonCauses = commonCauses;
                        $scope.currentCommonCauses = commonCauses;
                    }
                    else {
                        $scope.$parent.next(true);
                    }
                });
            },
            function (status) {
                if (status.status === 404) $scope.$parent.next();
            });

        $scope.selectCommonCause = function (index) {
            $scope.currentCommonCauses[index].$get('subCommonCauses').then(function (resource) {
                    if (resource != null && resource.page.totalElements > 0) {
                        resource.$get("commonCauseList").then(function (commonCauses) {
                            if (commonCauses != null && commonCauses.length > 0) {
                                $scope.currentCommonCauses = commonCauses;
                            } else {
                                next(index);
                            }
                        }, function (status) {
                            if (status.status === 404) next(index);
                        })
                    }
                },
                function (status) {
                    if (status.status === 404) next(index);
                });
        };

        $scope.goBack = function () {
            $scope.currentCommonCauses = $scope.parentCommonCauses;
        };

        function next(index) {
            serviceRequestSignOut.setCommonCause($scope.currentCommonCauses[index]);
            $scope.$parent.next();
        }
    }]);

    widgetsSignoutControllers.controller("wSingoutCupCountCtrl", ['$scope', '$translate', 'serviceRequestSignOut',
        function ($scope, $translate, serviceRequestSignOut) {

            $scope.cupCount = "";
            $scope.error = false;
            $scope.modelPropertyName = "";
            $scope.modelPropertyValues = [];
            $scope.cupCounts = [];

            serviceRequestSignOut.get().serviceRequest.$get('modelPropertyValues').then(
                function (resource) {
                    resource.$get("modelPropertyValueList").then(function (modelProperties) {
                        if (modelProperties != null && modelProperties.length > 0) {
                            $scope.modelPropertyName = modelProperties[0].name;
                            for (var i = 0; i < modelProperties.length; i++) {
                                var modelProperty = Object.assign({}, modelProperties[i]);
                                modelProperty.longPropertyValue = '';
                                $scope.modelPropertyValues.push(modelProperty);
                            }
                        } else {
                            $scope.modelPropertyName = $translate.instant('label.views.signout.modelProperties.CupCount');
                        }
                    });
                },
                function (status) {
                    if (status.status === 404) {
                        $scope.modelPropertyName = $translate.instant('label.views.signout.modelProperties.CupCount');
                    }
                }
            );

            function isInt(value) {
                return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
            }

            $scope.next = function () {
                var isError = false;
                for (var i = 0; i < $scope.modelPropertyValues.length; i++) {
                    var modelProperty = $scope.modelPropertyValues[i];
                    if (isInt(modelProperty.longPropertyValue)) {
                        $scope.modelPropertyValues[i].longPropertyValue = parseInt($scope.modelPropertyValues[i].longPropertyValue);
                    } else {
                        isError = true;
                        break;
                    }
                }

                if(isError) {
                    $scope.error = true;
                } else {
                    serviceRequestSignOut.setModelPropertyValues($scope.modelPropertyValues);
                    $scope.$parent.next();
                }
            }
        }]);

    widgetsSignoutControllers.controller("wSignOutTimeCtrl", ['$scope', '$translate', 'serviceRequestSignOut', 'storeService', 'clockService', '$filter',
        function ($scope, $translate, serviceRequestSignOut, storeService, clockService, $filter) {
            $scope.error = false;

            clockService.getTime().then(function (response) {                
                $scope.maxDate = response.storeTime;

                var maxDate = new Date(response.storeTime);
                maxDate.setMinutes(maxDate.getMinutes() + 1);

                if (serviceRequestSignOut.get().signOutTime != null && serviceRequestSignOut.get().signOutTime <= maxDate) {
                    $scope.signOutTime = serviceRequestSignIn.get().signOutTime;
                } else {
                    $scope.signOutTime = maxDate;
                }
            });

            serviceRequestSignOut.getMinSignOutDate().then(function (value) {
                if (value !== null) {
                    $scope.minDate = new Date(value);
                }
            });

            $scope.validationSignOutTime = function (value) {
                // update the maxDate to the current time (if the minute has change since the page had been open)
                return clockService.getTime().then(function (response) {
                    $scope.maxDate = response.storeTime;
                    if (value == null || value == '') {
                        $scope.error = true;
                        $scope.timeErrorMessage = $translate.instant('label.controller.services.controller.EnterTime');
                    } else if (clockService.roundedUpDate(value) < $scope.minDate) {
                        $scope.error = true;
                        $scope.timeErrorMessage = 'The minimum time allowed is ' + $filter('date')($scope.minDate, 'yyyy-MM-dd HH:mm');
                    } else if (clockService.getStringFromTime(clockService.roundedDownDate(value)) > $scope.maxDate) {
                        $scope.error = true;
                        $scope.timeErrorMessage = 'The maximum time allowed is ' + $filter('date')($scope.maxDate, 'yyyy-MM-dd HH:mm');
                    } else {
                        $scope.error = false;
                    }
                });
            };


            $scope.updateSignOutTime = function (value) {
                $scope.validationSignOutTime(value);
                $scope.signOutTime = value;
                serviceRequestSignOut.setSignOutTime(value);
            };

            $scope.next = function () {
                $scope.validationSignOutTime($scope.signOutTime).then(function () {
                    if ($scope.error) {
                        return;
                    }
                    serviceRequestSignOut.setSignOutTime($scope.signOutTime);
                    $scope.$parent.next();
                });
            };
            
        }]);

    widgetsSignoutControllers.controller("wSignOutVisitOutcomeCtrl", ['$scope', '$translate', 'lookUpService', 'serviceRequestSignOut', 'storeService', 'clockService',
        function ($scope, $translate, lookUpService, serviceRequestSignOut, storeService, clockService) {

            var partNotAvailable = false;

            // To avoid conficts if the user go back from other steps.
            // BEGIN -->
            var storeID = serviceRequestSignOut.get().store.id;
            var scheduleVisit = {
                scheduled: false,
                date: clockService.getTime(storeID).storeTime
            };
            serviceRequestSignOut.setScheduledVisit(scheduleVisit);
            // <-- END

            $scope.widgetInfo = {
                step: 0,
                goBack: false,
                title: $translate.instant('label.controller.services.signOutController.VisitOutcome')
            };

            $scope.visitOutcomes = [];
            $scope.subVisitOutcomes = [];
            $scope.outcome = {};

            lookUpService.list('visitOutcome').then(function (resource) {
                resource.$get("visitOutcomeList").then(function (visitOutcomes) {
                    $scope.visitOutcomes = visitOutcomes;
                });
            });

            var skipSubVisitOutComes = false;
            $scope.selectVisitOutcome = function (index) {

                if (!partNotAvailable) partNotAvailable = ($scope.visitOutcomes[index].name == "PART_MISSING");
                $scope.outcome.outcome = $scope.visitOutcomes[index];

                if ($scope.visitOutcomes[index].subVisitOutcomes != null
                    && $scope.visitOutcomes[index].subVisitOutcomes.length > 0) {
                    $scope.subVisitOutcomes = $scope.visitOutcomes[index].subVisitOutcomes;
                    $scope.widgetInfo.step++;
                } else {
                    skipSubVisitOutComes = true;
                    next();
                }
            };

            function next() {
                $scope.outcome.partNotAvailable = partNotAvailable;
                serviceRequestSignOut.setOutcome($scope.outcome);
                if (skipSubVisitOutComes) {
                    $scope.$parent.jump(1);
                } else {
                    $scope.$parent.next();
                }
            }

            $scope.selectSubVisitOutcome = function (index) {
                $scope.outcome.subOutcome = $scope.subVisitOutcomes[index];
                next();
            };

            $scope.$watch('widgetInfo.step', function (newValue, oldValue) {
                switch (newValue) {
                    case 0:
                        $scope.widgetInfo.title = $translate.instant('label.controller.services.signOutController.VisitOutcome');
                        $scope.widgetInfo.goBack = false;
                        break;
                    case 1:
                        $scope.widgetInfo.title = $translate.instant('label.controller.services.signOutController.SubVisitOutcome');
                        $scope.widgetInfo.goBack = true;
                        break;
                }
            });

            $scope.goBack = function () {
                $scope.widgetInfo.step--;
            };
        }]);

    widgetsSignoutControllers.controller("wSignOutOutcomeNoteCtrl",
        ['$scope', 'serviceRequestSignOut', 'serviceRequestService', function ($scope, serviceRequestSignOut, serviceRequestService) {

            serviceRequestSignOut.get().serviceRequest.$get('avoidableCallTypes').then(
                function (resource) {
                    if (resource != null && resource.length > 0) {
                        $scope.avoidableCallTypes = resource;
                        $scope.avoidableCallType = resource[0].code;
                    }
                },
                function (status) {
                    if (status.status === 404) $scope.$parent.next();
                });

            $scope.notes = "";
            $scope.error = false;
            var minLength = 10;

            $scope.avoidableCallVisibility = serviceRequestSignOut.get().outcome != null ?
            serviceRequestSignOut.get().outcome.outcome.name == "RESOLVED" : false;

            $scope.machineOperationalVisibility = serviceRequestSignOut.get().outcome != null ?
            serviceRequestSignOut.get().outcome.outcome.name != 'RESOLVED' : false;

            $scope.next = function (value) {
                serviceRequestService.isMachineOperationSetting().then(function (response) {
                    var isMachineOperationalRequired = response.content;

                    if($scope.machineOperationalVisibility) {
                        if (isMachineOperationalRequired && $scope.machineOperational == null) {
                            $scope.machineOperationalError = true;
                        } else {
                            $scope.machineOperationalError = false;
                        }
                    }

                    if ($scope.notes == "" || ($scope.notes.length < minLength)) {
                        $scope.notesError = true;
                    } else {
                        $scope.notesError = false;
                    }

                    if($scope.machineOperationalError || $scope.notesError) {
                        $scope.error = true;
                        return;
                    } else {
                        $scope.error = false;
                    }

                    serviceRequestSignOut.setAvoidableCall($scope.avoidableCallType);
                    serviceRequestSignOut.setMachineOperational($scope.machineOperational);
                    serviceRequestSignOut.setAdditionalNotes($scope.notes);
                    $scope.$parent.next();
                });
            };
        }]);

    widgetsSignoutControllers.controller("wSignOutEngineerSignatureCtrl", ['$scope', 'serviceRequestSignOut',
        function ($scope, serviceRequestSignOut) {

            $scope.signOff = {
                engineer: false
            };

            $scope.continue = function (value) {
                serviceRequestSignOut.setEngineerSignature(value);
                serviceRequestSignOut.setEngineerSignOff($scope.signOff.engineer);
                $scope.$parent.next();
            };
        }]);

    widgetsSignoutControllers.controller("wSignOutManagerSignatureCtrl", ['$scope', 'serviceRequestSignOut',
        function ($scope, serviceRequestSignOut) {

            $scope.signOff = {
                store: false
            };
            $scope.usedParts = [];
            $scope.usedParts = serviceRequestSignOut.get().usedParts;
            $scope.continue = function (value) {
                serviceRequestSignOut.setManagerSignature(value);
                serviceRequestSignOut.setStoreSignOff($scope.signOff.store);
                $scope.$parent.next();
            };
        }]);

    widgetsSignoutControllers.controller("wSignOutAuthenticateManagerCtrl", ['$scope', 'serviceRequestSignOut',
        function ($scope, serviceRequestSignOut) {
            $scope.manager = serviceRequestSignOut.get().manager;
        }]);

    widgetsSignoutControllers.controller("wSignOutAuthenticateEngineerCtrl", ['$scope', 'serviceRequestSignOut',
        function ($scope, serviceRequestSignOut) {
            $scope.engineer = serviceRequestSignOut.get().engineer;
            serviceRequestSignOut.get().engineer.$get("user").then(function (user) {
                $scope.engineer = user;
            });
        }]);

    widgetsSignoutControllers.controller("wSignOutManagerSelectCtrl", ['$scope', 'serviceRequestSignOut',
        function ($scope, serviceRequestSignOut) {

            $scope.processUser = function (user) {
                serviceRequestSignOut.setManager(user);
                serviceRequestSignOut.setSignedOutBy(user.username);
            }
        }]);

    widgetsSignInServiceRequestControllers.controller("wSignOutFinishCtrl",
        ['$scope', '$location', 'serviceRequestService', 'serviceRequestSignOut', 'localStorageService', 'storageKeys', '$element', 'storeService', 'clockService', 'serviceRequestView',
            function ($scope, $location, serviceRequestService, serviceRequestSignOut, localStorageService, storageKeys, $element, storeService, clockService, serviceRequestView) {
                $scope.success = 0;
                $scope.review = {};
                $scope.saveResult = {};
                $scope.review.isSample = serviceRequestSignOut.get().isSample;
                $scope.review.signOutTime = serviceRequestSignOut.get().signOutTime;
                $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
                $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

                var serviceRequest = serviceRequestView.get().serviceRequest;

                serviceRequest.$get("serviceEvent").then(function (serviceEvent) {
                    serviceEvent.$get("machine").then(function (machine) {
                        $scope.review.machine = machine;
                        machine.$get("station").then(function (station) {
                            $scope.review.machine.station = station;
                        });
                        machine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                            $scope.review.machine.partsWithExtendedWarranty = partsWithExtendedWarranty.components;
                            $scope.review.machine.isUnderWarranty = partsWithExtendedWarranty.underWarranty;
                            $scope.review.machine.isUnderComponentWarranty = partsWithExtendedWarranty.underComponentWarranty;
                        });
                    });
                });

                $scope.review.eta = serviceRequestSignOut.get().scheduledVisit.date;
                $scope.review.scheduled = serviceRequestSignOut.get().scheduledVisit.scheduled;
                $scope.review.additionalNotes = serviceRequestSignOut.get().additionalNotes;
                if (serviceRequestSignOut.get().commonCause != null) {
                    $scope.review.commonCause = serviceRequestSignOut.get().commonCause.description;
                }
                var profile = localStorageService.get(storageKeys.profileKey);

                var outcome;
                if (serviceRequestSignOut.get().outcome != null) {
                    outcome = serviceRequestSignOut.get().outcome.outcome.name;
                    $scope.review.outcome = serviceRequestSignOut.get().outcome.outcome.description;
                }

                var subOutcome;
                if (serviceRequestSignOut.get().outcome != null && serviceRequestSignOut.get().outcome.subOutcome != null) {
                    subOutcome = serviceRequestSignOut.get().outcome.subOutcome.name;
                    $scope.review.subOutcome = serviceRequestSignOut.get().outcome.subOutcome.description;
                }
                $scope.isSignedOut = false;

                $scope.signOut = function () {
                    var scheduleNewVisit = false;
                    $scope.isSignedOut = true;
                    if (!serviceRequestSignOut.get().isSample) {
                        scheduleNewVisit = serviceRequestSignOut.get().scheduledVisit.scheduled;
                    }

                    var visitToSave = {
                        serviceRequestId: serviceRequestSignOut.get().serviceRequest.id,
                        signOutTime: clockService.getStringFromTime(serviceRequestSignOut.get().signOutTime),
                        scheduleNewVisit: scheduleNewVisit,
                        eta: serviceRequestSignOut.get().scheduledVisit.date,
                        commonCause: serviceRequestSignOut.get().commonCause,
                        signOut: {
                            engineerSignatureOut: serviceRequestSignOut.get().engineerSignature,
                            engineerSignOff: serviceRequestSignOut.get().engineerSignOff,
                            managerSignatureOut: serviceRequestSignOut.get().managerSignature,
                            signedOutBy: serviceRequestSignOut.get().signedOutBy,
                            storeSignOff: serviceRequestSignOut.get().storeSignOff
                        },
                        note: {
                            author: profile.username,
                            creationTime: clockService.getStringFromTime(serviceRequestSignOut.get().signOutTime),
                            subject: "Sign Out Note",
                            text: serviceRequestSignOut.get().additionalNotes,
                            privacyStatus: "PUBLIC",
                            noteType: "SIGN_OUT"
                        },
                        outcome: outcome,
                        missingParts: serviceRequestSignOut.get().missingParts,
                        usedParts: serviceRequestSignOut.get().usedParts,
                        subOutcome: subOutcome,
                        serviceActionType: serviceRequestSignOut.get().serviceActionType,
                        partsWithExtendedWarranty: serviceRequestSignOut.get().partsWithExtendedWarranty,
                        avoidableCall: serviceRequestSignOut.get().avoidableCall,
                        machineOperational: serviceRequestSignOut.get().machineOperational,
                        modelPropertyValue: {
                            longPropertyValue: serviceRequestSignOut.get().modelPropertyValue
                        },
                        modelPropertyValues: serviceRequestSignOut.get().modelPropertyValues,
                        noPartSelection: serviceRequestSignOut.get().noPartSelection
                    };

                    serviceRequestService.signout(visitToSave).then(
                        function (response) {
                            $scope.saveResult = response;
                            $scope.success = 1;
                            serviceRequestSignOut.reset();
                            $scope.$parent.finish();
                        },
                        function (status) {
                            if (status.status !== 200) {
                                // Something went wrong
                                $scope.success = -1;
                            }
                        }
                    );
                };

                $scope.openExtendedWarrantyModal = function () {
                    $('#openExtendedWarrantyLoader').show();
                    $scope.review.machine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                        $scope.partsWithExtendedWarranty = partsWithExtendedWarranty.components;
                        $('#extendedWarrantyModal').modal("show");
                        $('#openExtendedWarrantyLoader').hide();
                    });
                };

                $scope.goBack = function () {
                    $location.path("/");
                }
            }]);

    widgetsSignoutControllers.controller("wSingoutNextVisitCtrl",
        ['$scope', 'serviceRequestSignOut', 'clockService', function ($scope, serviceRequestSignOut, clockService) {

            if (serviceRequestSignOut.get().outcome.outcome.name == "RESOLVED" ||
                serviceRequestSignOut.get().outcome.outcome.name == "CANNOT_REPRODUCE"){
                $scope.$parent.next(true);
            }

            $scope.scheduleVisit = false;
            $scope.nextDate = new Date();

            $scope.updateNextDate = function (value) {
                $scope.nextDate = value;
            };

            $scope.next = function () {
                var scheduleVisit = {
                    scheduled: $scope.scheduleVisit,
                    date: clockService.getStringFromTime($scope.nextDate)
                };

                serviceRequestSignOut.setScheduledVisit(scheduleVisit);
                $scope.$parent.next();
            };
        }]);


    widgetsSignoutControllers.controller("wSingoutSurveyCtrl",
        ['$scope', '$sce', 'serviceRequestSignOut', 'surveyService', function ($scope, $sce, serviceRequestSignOut, surveyService) {

            $scope.surveyUrl = "";

            surveyService.getSurvey(239).then(function (resource) {
                $scope.surveyUrl = $sce.trustAsResourceUrl(resource.url);
            });

            $scope.next = function () {
                $scope.$parent.next();
            }
        }]);

    widgetsSignoutControllers.controller("wSignoutStoreWithSampleSignatureCtrl",
        ['$scope', 'serviceRequestService', 'serviceRequestSignOut', function ($scope, serviceRequestService, serviceRequestSignOut) {

            $scope.sample = false;

            $scope.continue = function (value) {
                serviceRequestSignOut.setManagerSignature(value);
                serviceRequestSignOut.setIsSample(true);
                $scope.$parent.next();
            };
        }]);

    widgetsSignoutControllers.controller("wSignOutPartsExtendedWarrantyCtrl",
        ['$scope', 'serviceRequestSignOut', '$translate', 'localStorageService', 'storageKeys', function ($scope, serviceRequestSignOut, $translate, localStorageService, storageKeys) {

            $scope.appDateTimeFormat = localStorageService.get(storageKeys.appDateTimeFormat);
            $scope.appDateFormat = localStorageService.get(storageKeys.appDateFormat);

            $scope.widgetInfo = {
                step: 5,
                goBack: true,
                title: $translate.instant('label.controller.services.signOutController.PartsExtendedWarranty'),
                description: $translate.instant('label.controller.services.signOutController.PartsExtendedWarrantyDescription')
            };

            var serviceRequest = serviceRequestSignOut.get().serviceRequest;
            serviceRequest.$get("serviceEvent").then(function (event) {
                event.$get("machine").then(function (machine) {
                    machine.$get("partsWithExtendedWarranty").then(function (partsWithExtendedWarranty) {
                        if (!partsWithExtendedWarranty.underComponentWarranty) {
                            $scope.$parent.next(true);
                        } else {
                            var list = partsWithExtendedWarranty.components;
                            $scope.partsWithExtendedWarranty = [];
                            angular.forEach(list, function (value, key) {
                                // TODO: do we really have to duplicate the list into a new array of modifiable objects?
                                // angular-hal returns a list of resources with read-only, non-configurable properties, so
                                // quantity can not be set directly
                                $scope.partsWithExtendedWarranty.push({
                                    'id': value.id,
                                    'partNumber': value.partNumber,
                                    'description': value.description,
                                    'coverPeriodMonths': value.coverPeriodMonths,
                                    'warrantyEnd': value.warrantyEnd,
                                    'quantity': value.quantity
                                });
                            });
                        }
                    }, function (error) {
                        $scope.$parent.next(true);
                    });
                });
            });

            $scope.next = function () {
                serviceRequestSignOut.setPartsWithExtendedWarranty($scope.partsWithExtendedWarranty);
                $scope.$parent.next();
            };
        }]
    );
}(angular);